import { usdFine as usd } from "@/components/ai/useAiEdits";

// Spent vs budget bar: amber from the warning threshold, red when the budget is reached.
export function BudgetBar({ spent = 0, budget, warn = 80, testid = "budget-bar" }) {
  if (!budget) return null;
  const pct = Math.round((spent / budget) * 1000) / 10;
  const tone = pct >= 100 ? "bg-red-500" : pct >= warn ? "bg-amber-500" : "bg-sky-600";
  return (
    <div data-testid={testid}>
      <div className="flex items-center justify-between text-[11px] text-slate-600">
        <span className="tabular-nums">{usd(spent)} di {usd(budget)}</span>
        <span className={`tabular-nums font-medium ${pct >= 100 ? "text-red-600" : pct >= warn ? "text-amber-700" : "text-slate-700"}`} data-testid={`${testid}-pct`}>{pct.toLocaleString("it-IT")}%</span>
      </div>
      <div className="mt-1 h-1.5 rounded-full bg-slate-100 overflow-hidden">
        <div className={`h-full rounded-full transition-[width] duration-500 ${tone}`} style={{ width: `${Math.min(100, pct)}%` }} />
      </div>
    </div>
  );
}
